import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  text: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  age,
  city,
  text,
  delay = 0
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-lg border border-purple-100 flex flex-col h-full relative" data-id="element-46">
      <Quote className="absolute top-4 right-4 text-purple-200 w-8 h-8" data-id="element-47" />
      <p className="text-gray-700 italic mb-6 flex-grow relative z-10" data-id="element-48">
        "{text}"
      </p>
      <div className="flex items-center gap-3 mt-auto border-t border-purple-50 pt-4" data-id="element-49">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center text-white font-bold text-sm" data-id="element-50">
          {name.charAt(0)}
        </div>
        <div data-id="element-51">
          <p className="font-bold text-gray-900 text-sm" data-id="element-52">
            {name}, {age}
          </p>
          <p className="text-xs text-purple-600" data-id="element-53">{city}</p>
        </div>
      </div>
    </motion.div>;
}